function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Auth } from '@nackle/bridge';
export default function (umbrella) {
  var applyRequestMiddleware = umbrella.applyRequestMiddleware,
    getURL = umbrella.getURL;
  var auth = null;
  function getAuth() {
    var enableTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var activityTimeoutInMinutes = arguments.length > 1 ? arguments[1] : undefined;
    var activityPromptInMinutes = arguments.length > 2 ? arguments[2] : undefined;
    var additionalProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var createNewAuth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (!auth || createNewAuth) {
      auth = new Auth(_objectSpread({
        authority: additionalProps.authority || getURL('https://(env.)api.biw.cloud/v1/id'),
        enableActivityTimeout: enableTimeout,
        activityTimeoutInMinutes: activityTimeoutInMinutes,
        activityPromptInMinutes: activityPromptInMinutes
      }, additionalProps));
    }
    return auth;
  }
  applyRequestMiddleware(function (url, options) {
    if (auth) {
      options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, {
        'x-company-identifier': "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(window.location.port ? ":".concat(window.location.port) : '')
      });
      var companyId = auth.state.claims.company_id;
      if (companyId) {
        options.headers['company-id'] = companyId;
      }
      var accessToken = auth.state.access_token;
      if (accessToken) {
        options.headers.authorization = "Bearer ".concat(accessToken);
      }
    }
  });
  umbrella.getAuth = getAuth;
}
//# sourceMappingURL=auth.js.map